import Vue from 'vue'
const eventBus = new Vue();
export {
  eventBus
};



// WEBPACK FOOTER //
// ./src/common/util/eventBus.js